const windowMs=7*86400000;
export function validRecommendationClick(value:unknown,now=Date.now()):string|undefined {
 if(!value||typeof value!=='object')return;
 const row=value as {eventId?:unknown;at?:unknown};
 if(typeof row.eventId!=='string'||!/^[a-f0-9-]{36}$/i.test(row.eventId)||typeof row.at!=='number'||!Number.isFinite(row.at)||row.at>now||now-row.at>windowMs)return;
 return row.eventId;
}
const key=(storeKey:string)=>`smartyfind_recommendation_click_${storeKey.slice(-16)}`;
export function rememberRecommendationClick(storeKey:string,eventId:string):void {
 try{localStorage.setItem(key(storeKey),JSON.stringify({eventId,at:Date.now()}));}catch{/* Storage must not block navigation. */}
}
export function currentRecommendationClick(storeKey:string):string|undefined {
 try{return validRecommendationClick(JSON.parse(localStorage.getItem(key(storeKey))??'null'));}catch{return;}
}
